import { Component, computed, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderNavigationalButtonComponent } from '../../shared/header-navigational-button/header-navigational-button.component';
import { ConfigService } from '../services/config.service';
import { StoreIdService } from '../services/store-id.service';
import { AuthService } from '../services/auth.service';
import { ModalName, ModalService } from '../services/modal.service';
import { TranslocoDirective } from '@ngneat/transloco';
import { FeaturedContent } from '../models/core/featured-content.model';
import { FeaturedContentService } from '../services/featured-content.service';
import { FeaturedContentName } from '../models/core/featured-content-name.enum';
import { IconComponent } from '../../shared/icons/icon.component';
import { IconNameType } from '../../shared/icons/icon-name-type.enum';
import { PremiumService } from '../../loyalty/premium/premium.service';

@Component({
  selector: 'cwo-mobile-nav-menu',
  standalone: true,
  imports: [
    CommonModule,
    HeaderNavigationalButtonComponent,
    TranslocoDirective,
    IconComponent,
  ],
  templateUrl: './mobile-nav-menu.component.html',
  styleUrl: './mobile-nav-menu.component.scss',
})
export class MobileNavMenuComponent implements OnInit{
  accountMenuExpanded = false;
  isLoggedIn = computed(() => this.authService.state().isLoggedIn);
  iconName = IconNameType;

  modalService = inject(ModalService);
  configService = inject(ConfigService);
  authService = inject(AuthService);
  storeIdService = inject(StoreIdService);

  private featuredContentService = inject(FeaturedContentService);
  headerFeaturedContentLinks: FeaturedContent[] = [];

  configState = this.configService.configState;

  premiumService = inject(PremiumService);

  isMobileSideNavOpen() {
    return this.modalService.isModalOpen(ModalName.MobileSideNav);
  }

  toggleLoggedIn() {    
    if(!this.isLoggedIn()){
      this.modalService.openModal(ModalName.SignIn);
    } else {
      this.authService.logout().subscribe(() => {
        const pathname = location.pathname.split('/');
        
        window.location.href = `${pathname.length > 0 && `/${pathname[1]}`}/${this.storeIdService.getStorePathPrefix()}`;
      })
    }
  }

  ngOnInit(): void {
    this.headerFeaturedContentLinks = this.featuredContentService.getFeaturedContentsByAreaName(FeaturedContentName.HEADER_LINKS);
  }


  public openStoreSelectionModal(): void {
    this.modalService.closeAllModals().subscribe(
        () => {
          this.modalService.openModal(ModalName.OrderDetails, {
              showStoreChooser: true,
          });
        });
  }
}